import { render, staticRenderFns } from "./EbookCard.vue?vue&type=template&id=7a327c10&"
import script from "./EbookCard.vue?vue&type=script&lang=js&"
export * from "./EbookCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports